module.exports = __webpack_public_path__ + "img/venus10.718afeea.png";